import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export default styled.div<{ isSymmetrical: boolean }>`
  display: flex;
  justify-content: center;
  padding: 1rem 0;

  .speed-container {
    display: flex;
    flex-direction: row;
    align-items: center;

    &:nth-child(2) {
      border-left: solid 1px #dcdde2;
      padding-left: 0.9rem;
    }

    > div:nth-child(1) {
      margin-right: 2px !important;

      @media ${breakpoints.tablet} {
        margin-right: 0.5rem !important;
      }
    }

    > div:nth-child(2) {
      > span:first-child {
        font-size: 1.8rem;
        font-weight: bold;
        color: var(--colors-white);
      }
      > span:nth-child(2) {
        color: var(--colors-white);
        font-size: 0.75rem;
      }
      > p:nth-child(3) {
        color: var(--colors-white);
        font-size: 0.75rem;
      }
    }
  }

  .symmetrical-speed-container {
    position: relative;
    display: flex;
    align-items: center;
    padding: 1rem;
    & > p {
      font-size: 0.625rem;
      font-weight: bold;
      text-align: center;
    }
    & > p:before {
      content: '';
      position: absolute;
      inset: 0;
      background: transparent linear-gradient(247deg, #f4111b 0%, #dc1031 41%, #0402fd 100%) 0 0
        no-repeat padding-box;
      opacity: 0.2;
    }
  }
`;
